import { ModalWindowService } from '@anecdotes/design-system/modals';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-access-granted-modal',
  templateUrl: './access-granted-modal.component.html',
  styleUrls: ['./access-granted-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessGrantedModalComponent {
  constructor(private modalWindowService: ModalWindowService) {}

  buildTranslationKey(key: string): string {
    return `trustCenter.${key}`;
  }

  closeModal(): void {
    this.modalWindowService.close();
  }
}
